import React, { useState, useEffect } from 'react';
import './Verify_otp.css'; 
import { useNavigate } from 'react-router-dom';

function VerifyOtp() {
    const [otp, setOtp] = useState(["", "", "", ""]);
    const [loading, setLoading] = useState(false); 
    const [error, setError] = useState("");
    const [success, setSuccess] = useState(""); 
    const [timer, setTimer] = useState(0); 

    const navigate = useNavigate();

    const passwordNV = () => {
        navigate('/password-update');
    };

    useEffect(() => {
        const savedEndTime = localStorage.getItem("otpEndTime");
        const currentTime = new Date().getTime();

        if (savedEndTime) {
            const remainingTime = Math.floor((savedEndTime - currentTime) / 1000);
            if (remainingTime > 0) {
                setTimer(remainingTime);
            } else {
                setTimer(0); 
            }
        } else {
            const defaultTime = 300
            const newEndTime = currentTime + defaultTime * 1000;
            localStorage.setItem("otpEndTime", newEndTime);
            setTimer(defaultTime);
        }
    }, []);

    useEffect(() => {
        if (timer > 0) {
            const countdown = setInterval(() => {
                setTimer((prevTimer) => {
                    const newTimer = prevTimer - 1;
                    if (newTimer <= 0) {
                        clearInterval(countdown);
                        localStorage.removeItem("otpEndTime");
                    }
                    return newTimer;
                });
            }, 1000);

            return () => clearInterval(countdown);
        }
    }, [timer]);

    const handleChange = (e, index) => {
        const value = e.target.value;

        if (value === "" || /^[0-9]$/.test(value)) {
            const newOtp = [...otp];
            newOtp[index] = value;
            setOtp(newOtp);

           
            if (value !== "" && index < 3) {
                document.getElementById(`otp-input-${index + 1}`).focus();
            }
        }
    };

    const handleKeyDown = (e, index) => {
        
        if (e.key === "Backspace" && otp[index] === "") {
            if (index > 0) {
                document.getElementById(`otp-input-${index - 1}`).focus();
            }
        }
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        const otpCode = otp.join(""); 
        const userId = sessionStorage.getItem('user_id');
        if (otpCode.length !== 4) {
            setError("Please enter the full OTP.");
            return;
        }

        
        setLoading(true);
        setError("");
        setSuccess("");

        const myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");

        const raw = JSON.stringify({
            otp_code: otpCode,
            user_id: userId,
        });

        const requestOptions = {
            method: "POST",
            headers: myHeaders,
            body: raw,
            redirect: "follow",
        };

        fetch("https://api.libaonline.com/api/v1/verify_otp", requestOptions)
            .then((response) => response.json())
            .then((result) => {
                setLoading(false); 
                if (result?.status === 200) {
                    setSuccess("OTP verified successfully!");
                    setError(""); 
                    passwordNV();
                } else {
                    setError("Invalid OTP. Please try again.");
                    setSuccess(""); 
                }
            })
            .catch((error) => {
                setLoading(false); 
                setError("An error occurred. Please try again.");
                setSuccess(""); 
                console.error("API Error:", error);
            });
    };

    const formatTime = (seconds) => {
        const minutes = Math.floor(seconds / 60);
        const remainingSeconds = seconds % 60;
        return `${minutes}:${remainingSeconds < 10 ? "0" : ""}${remainingSeconds}`;
    };

    return (
        <div className="verify_otp">
            <div className="verify-otp-container">
                <div className="card col-lg-6">
                    <h2 className="verify-otp-header">Verify OTP</h2>
                    <form onSubmit={handleSubmit} className="verify-otp-form">
                        <div className="row otp-inputs">
                            {otp.map((digit, index) => (
                                <div className="col-lg-3" key={index}>
                                    <input
                                        type="text"
                                        id={`otp-input-${index}`}
                                        value={digit}
                                        onChange={(e) => handleChange(e, index)}
                                        onKeyDown={(e) => handleKeyDown(e, index)}
                                        maxLength="1"
                                        className="otp-input"
                                        autoFocus={index === 0}
                                    />
                                </div>
                            ))}
                        </div>
                        {timer > 0 ? (
                            <div className="countdown-timer">Time left: {formatTime(timer)}</div>
                        ) : (
                            <div className="error-message">OTP has expired. Please request a new OTP.</div>
                        )}
                        {error && <div className="error-message">{error}</div>}
                        {success && <div className="success-message">{success}</div>}
                        <button type="submit" className="verify-otp-button" disabled={loading || timer === 0}>
                            {loading ? "Verifying..." : "Verify OTP"}
                        </button>
                    </form>
                </div>
            </div>
        </div>
    );
}

export default VerifyOtp;
